module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/InfluencerExample/5_icon-f7474c3e6b90196d37010c0fdd8dfe33.png";